export default __webpack_public_path__ + "static/media/uobt.da01bc2c.svg";